module.exports = __webpack_public_path__ + "static/oracle-tech-1cb350c2c32f3f60b5bd965a08b07ddb.jpg";